/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
"use strict";
exports.FILL_STYLE_FLAG = 'true'; // TODO (matsko): change to boolean
exports.ANY_STATE = '*';
exports.DEFAULT_STATE = '*';
exports.EMPTY_STATE = 'void';
//# sourceMappingURL=animation_constants.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@angular/core/src/animation/animation_constants.js
 ** module id = 95
 ** module chunks = 2
 **/